import styles from './or.module.scss'
import { cn } from 'utils/helpers'

export default function Or({ className }) {
    return (
        <div className={cn(styles.or, className)}>
            <span>arba el. paštu</span>
        </div>
    )
}
